import React from 'react';
import './styling/Header.css';

export default function Header() {
  return (
    <header className="app-header">
      <h1>DevTools Tracker</h1>
    </header>
  );
}
